module.exports = __webpack_public_path__ + "static/media/dash.696155f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/dash.svg
// module id = 602
// module chunks = 0